import React, { useContext } from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { CopilotError, useErrorViewStyles } from '@bingads-webui/ads-copilot-ui';
import { I18nContext, type I18nModel } from '@bingads-webui/copilot-i18n';
import { Header } from '@bingads-webui-react/copilot-ui-base';

interface ICopilotDegradeErrorViewProps {
  onDegrade(): void;
  onClose(): void;
}

export const CopilotDegradeErrorView: React.FC<ICopilotDegradeErrorViewProps> = ({
  onDegrade, onClose,
}) => {
  const i18n = useContext(I18nContext) as I18nModel;
  const styles = useErrorViewStyles();

  return (
    <div className={styles.root}>
      <Header
        showRefreshButton={false}
        onClose={onClose}
      />
      <div className={mergeClasses(styles.errorWrapper, 'error-wrapper')}>
        <CopilotError
          errorTitle={i18n.getString(_TL_('Copilot is down for now'))}
          errorText={i18n.getString(_TL_('We are working hard to fix the issue. If you have any questions, you can connect to live agent.'))}
          tryAgainButtonText={i18n.getString(_TL_('Connect to live agent'))}
          onRefresh={onDegrade}
        />
      </div>
    </div>
  );
};
